export enum ORDER_STATUS {
  Initialize = 'initialize',
  Waiting = 'waiting',
  DriverVerify = 'driver-verify',
  DriverConfirmed = 'driver-confirmed',
  ClientPaying = 'client-paying',
  DriverConfirmingPayment = 'driver-confirming-payment',
  PaymentFailure = 'payment-failure',
  DriverToShop = 'driver-to-shop',
  DriverDelivery = 'driver-delivery',
  Completed = 'completed',
  AutoCompleted = 'auto-completed',
  Canceled = 'canceled',
}

export const ORDER_STATUS_LABEL: Record<ORDER_STATUS, string> = {
  [ORDER_STATUS.Initialize]: 'Đang tìm tài xế',
  [ORDER_STATUS.Waiting]: 'Đang chờ tài xế',
  [ORDER_STATUS.DriverVerify]: 'Tài xế đã nhận đơn',
  [ORDER_STATUS.DriverConfirmed]: 'Tài xế đã xác nhận',
  [ORDER_STATUS.ClientPaying]: 'Chờ khách thanh toán',
  [ORDER_STATUS.DriverConfirmingPayment]: 'Tài xế xác nhận thanh toán',
  [ORDER_STATUS.PaymentFailure]: 'Thanh toán thất bại',
  [ORDER_STATUS.DriverToShop]: 'Tài xế đang đến quán',
  [ORDER_STATUS.DriverDelivery]: 'Tài xế đang giao',
  [ORDER_STATUS.Completed]: 'Đơn hoàn thành',
  [ORDER_STATUS.AutoCompleted]: 'Tự động hoàn thành',
  [ORDER_STATUS.Canceled]: 'Đơn đã hủy',
};

export const ORDER_STATUS_COLOR: Record<string, string> = {
  [ORDER_STATUS.Initialize]: 'blue',
  [ORDER_STATUS.Waiting]: 'cyan',
  [ORDER_STATUS.DriverVerify]: 'processing',
  [ORDER_STATUS.DriverConfirmed]: 'orange',
  [ORDER_STATUS.ClientPaying]: 'gold',
  [ORDER_STATUS.DriverConfirmingPayment]: 'warning',
  [ORDER_STATUS.PaymentFailure]: 'error',
  [ORDER_STATUS.DriverToShop]: 'geekblue',
  [ORDER_STATUS.DriverDelivery]: 'purple',
  [ORDER_STATUS.Completed]: 'green',
  [ORDER_STATUS.AutoCompleted]: 'success',
  [ORDER_STATUS.Canceled]: 'red',
  // Backward compatibility
  'ship-confirmed': 'orange',
  'ship-delivery': 'purple',
};
